import styled from "styled-components";
import {
  BASIC_BLACK,
  BASIC_BROWN,
  BASIC_GRAY,
  BASIC_ORANGE,
  BASIC_WHITE,
} from "../../constants/colors";

type Props = {
  text: string;
  checkboxStyle?: "primary" | "secondary" | "selection";
  disabled?: boolean;
  onChange?: (checked: boolean) => void;
};

export const Checkbox: React.FC<Props> = ({
  onChange,
  disabled,
  text,
  checkboxStyle = "primary",
}) => {
  return (
    <CheckboxContainer>
      <StyledCheckbox
        type="checkbox"
        onChange={(e) => onChange?.(e.target.checked)}
        disabled={disabled}
        $checkboxStyle={checkboxStyle}
      />
      <CheckboxLabel disabled={disabled ?? false}>{text}</CheckboxLabel>
    </CheckboxContainer>
  );
};

const CheckboxContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const StyledCheckbox = styled.input<{
  $checkboxStyle?: "primary" | "secondary" | "selection";
}>`
  height: 24px;
  width: 24px;
  margin: 0;
  padding: 0;
  opacity: 1;
  appearance: none;
  border: 1px solid
    ${({ disabled, $checkboxStyle }) =>
      disabled
        ? BASIC_GRAY
        : $checkboxStyle === "selection"
          ? BASIC_ORANGE
          : BASIC_BLACK};
  background: ${BASIC_WHITE};
  position: relative;
  vertical-align: -5px;
  margin-right: 12px;
  &:hover {
    cursor: pointer;
  }
  &:checked {
    border: 1px solid
      ${({ $checkboxStyle }) =>
        $checkboxStyle === "selection" ? BASIC_ORANGE : BASIC_BLACK};
    background: ${({ $checkboxStyle }) =>
      $checkboxStyle === "primary"
        ? BASIC_WHITE
        : $checkboxStyle === "secondary"
          ? BASIC_BROWN
          : $checkboxStyle === "selection"
            ? BASIC_ORANGE
            : BASIC_GRAY};
    &::before,
    &::after {
      content: "";
      position: absolute;
      height: 2px;
      border-radius: 10%;
      background: ${({ $checkboxStyle }) =>
        $checkboxStyle === "primary"
          ? BASIC_BLACK
          : $checkboxStyle === "secondary"
            ? BASIC_WHITE
            : $checkboxStyle === "selection"
              ? BASIC_WHITE
              : BASIC_GRAY};
    }
    &::before {
      width: 9px;
      top: 12px;
      left: 1.5px;
      transform: rotate(44deg);
    }
    &::after {
      width: 15px;
      top: 9.5px;
      left: 5.5px;
      transform: rotate(-48deg);
    }
  }
  &:focus {
    outline: none;
  }
  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
`;

const CheckboxLabel = styled.label<{
  disabled: boolean;
  $checkboxStyle?: "primary" | "secondary";
}>`
  color: ${({ disabled }) => (disabled ? BASIC_GRAY : BASIC_BLACK)};
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
  font-family: "Hiragino Sans";
  font-weight: ${({ $checkboxStyle }) =>
    $checkboxStyle === "primary" ? 600 : 400};
  font-size: ${({ $checkboxStyle }) =>
    $checkboxStyle === "primary" ? "16px" : "14px"};
`;
